var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#phone_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3E3E3E",
  d: "M6.625 10.795a15.06 15.06 0 0 0 6.59 6.585l2.2-2.205c.275-.275.67-.355 1.015-.245 1.12.37 2.325.57 3.57.57.555 0 1 .445 1 1V20c0 .555-.445 1-1 1-9.39 0-17-7.61-17-17a1 1 0 0 1 1-1h3.5c.555 0 1 .445 1 1 0 1.245.2 2.45.57 3.57.11.345.03.74-.245 1.015z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "phone_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgPhone;